/* Header behaviour: the off-canvas mobile navigation, and keyboard access
   to the desktop mega panels.

   The desktop panels open on hover and focus-within in CSS alone. This
   script only adds what CSS cannot do: closing an open panel on Escape,
   and toggling it from the keyboard via the parent link. */
(function () {
  var panel = document.querySelector('[data-nav-panel]');
  var overlay = document.querySelector('[data-nav-overlay]');
  var toggle = document.querySelector('[data-nav-toggle]');
  var closeBtn = document.querySelector('[data-nav-close]');
  var lastFocused = null;

  function openNav() {
    if (!panel) return;
    lastFocused = document.activeElement;
    panel.hidden = false;
    if (overlay) overlay.hidden = false;

    // Force a reflow so the transition runs from the closed position
    // rather than being collapsed into the same frame as the unhide.
    void panel.offsetWidth;

    panel.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    if (closeBtn) closeBtn.focus();
  }

  function closeNav() {
    if (!panel) return;
    panel.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';

    window.setTimeout(function () {
      panel.hidden = true;
      if (overlay) overlay.hidden = true;
    }, 300);

    if (lastFocused) lastFocused.focus();
  }

  if (toggle) toggle.addEventListener('click', openNav);
  if (closeBtn) closeBtn.addEventListener('click', closeNav);
  if (overlay) overlay.addEventListener('click', closeNav);

  // --- desktop mega panels ---------------------------------------------

  var parents = document.querySelectorAll('.pb-nav__item--has-menu > .pb-nav__link');

  function closeAllMegas() {
    document.querySelectorAll('.pb-mega.is-open').forEach(function (mega) {
      mega.classList.remove('is-open');
      var link = mega.parentElement.querySelector('.pb-nav__link');
      if (link) link.setAttribute('aria-expanded', 'false');
    });
  }

  parents.forEach(function (link) {
    link.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;

      var mega = link.parentElement.querySelector('.pb-mega');
      if (!mega) return;

      // Enter on a parent opens its panel instead of following the link,
      // which would otherwise make the child links unreachable by keyboard.
      event.preventDefault();
      var isOpen = mega.classList.contains('is-open');
      closeAllMegas();

      if (!isOpen) {
        mega.classList.add('is-open');
        link.setAttribute('aria-expanded', 'true');
      }
    });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    closeAllMegas();
    if (panel && panel.classList.contains('is-open')) closeNav();
  });

  // --- wishlist ---------------------------------------------------------

  /* Wishlist Hero binds the header anchor once, during its own init, by
     matching a[href='#hero-wishlist']. That leaves two gaps: the app script
     arriving after this markup, and the header being re-rendered later (a
     section reload in the theme editor), both of which drop the binding and
     leave the icon dead.

     Delegated on document so it survives re-renders, and it defers to the
     app: if the app's own listener already handled the click it will have
     called preventDefault, and this does nothing rather than firing a second
     open. The href is left to act as the fallback when the SDK is absent. */
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var link = target.closest('[data-pb-wishlist]');
    if (!link || event.defaultPrevented) return;
    if (!window.WishListHero_SDK || !window.WishListHero_SDK.OpenWishList) return;

    event.preventDefault();
    window.WishListHero_SDK.OpenWishList();
  });
})();
